import type { ReactElement } from 'react';
import styles from './SessionExpiredScreen.module.css';

export interface SessionExpiredScreenProps {
  /** Instante em que o cliente detectou a sessão expirada (HTTP 410) —
   * o backend não devolve o carimbo exato de invalidação do evento. */
  expiredAt: Date;
  onBack: () => void;
}

function formatUtcTimestamp(date: Date): string {
  return `${date.toISOString().replace('T', ' ').slice(0, 16)} UTC`;
}

/**
 * Tela de encerramento exibida quando uma sessão de dispositivo já
 * autenticada (PIN validado) expira ou é revogada durante o uso — HTTP 410
 * em qualquer chamada autenticada seguinte (HUB-235, CA-03). Cobre apenas
 * esse caso: nunca substitui a mensagem genérica anti-enumeração da tela de
 * entrada de PIN (HUB-21).
 *
 * Overlay bloqueante em tela cheia (`position: fixed`), sem indicador de
 * status — cobre visualmente o cabeçalho da `HomePage`.
 */
export function SessionExpiredScreen({
  expiredAt,
  onBack,
}: SessionExpiredScreenProps): ReactElement {
  return (
    <div
      className={styles.overlay}
      role="alertdialog"
      aria-modal="true"
      aria-label="Ativação encerrada"
    >
      <div className={styles.card}>
        <div className={styles.icon} aria-hidden="true">
          🚫
        </div>
        <h1 className={styles.heading}>Ativação Encerrada</h1>
        <p className={styles.message}>
          PIN expirado em {formatUtcTimestamp(expiredAt)}. Contate o suporte da agência para
          renovar.
        </p>
        <button type="button" className={styles.button} onClick={onBack}>
          Voltar
        </button>
      </div>
    </div>
  );
}
